import axios from 'axios';

// export const baseURL = 'http://192.168.0.185:8086/';
export const baseURL = 'https://aibackend-oucs.onrender.com/';
// export const baseURL = 'http://192.168.0.206:5000';
// export const baseURL = 'https://express-proxy-zuiv.onrender.com/api';
// export const baseURL = 'http://147.93.31.4:8086/';
// export const baseURL = 'https://elitecodo.com/';

// Create an Axios instance
export const httpClient = axios.create({
  baseURL,
});
